module.exports = __webpack_public_path__ + "static/media/400398_02.4eafdc36.png";